import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { COMMON_CONTAINER_ID } from '@/config';

type CopiedValue = string | null;
type CopyFn = (text: string) => Promise<boolean>;

function useCopyToClipboard(showToast = true): [CopiedValue, CopyFn] {
  const { t } = useTranslation();
  const [copiedText, setCopiedText] = useState<CopiedValue>(null);

  const copy: CopyFn = async (text) => {
    if (!navigator?.clipboard) {
      console.warn('Clipboard not supported');
      return false;
    }
    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      if (text.length && showToast) {
        toast.info(`${text} ${t('translation.is_copied_to_clipboard')}`, {
          autoClose: 3000,
          hideProgressBar: true,
          containerId: COMMON_CONTAINER_ID,
        });
      }
      return true;
    } catch (error) {
      console.warn('Copy failed', error);
      setCopiedText(null);
      return false;
    }
  };

  return [copiedText, copy];
}

export default useCopyToClipboard;
